import React from 'react'

const Flexbox_Coding_Pratice_5 = () => {
  return (
    <div>
      <h1>Flexbox Coding Practice 5</h1>
    </div>
  )
}

export default Flexbox_Coding_Pratice_5
